import { motion } from "framer-motion";

const Sparkle = ({ className = "" }) => (
    <svg
        viewBox="0 0 24 24"
        className={className}
        fill="none"
        aria-hidden
    >
        <path
            d="M12 2c0 5 2 7 7 7-5 0-7 2-7 7 0-5-2-7-7-7 5 0 7-2 7-7z"
            fill="currentColor"
        />
    </svg>
);

export const Contact = () => {
    return (
        <section
            id="contact"
            data-testid="contact-section"
            className="relative pt-10 md:pt-14 pb-12 md:pb-16"
        >
            <div className="max-w-7xl mx-auto px-6 md:px-12">
                <motion.span
                    initial={{ opacity: 0, y: 14 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.6 }}
                    className="font-accent text-coral text-3xl md:text-4xl block rotate-[-2deg]"
                >
                    Contact
                </motion.span>

                <div className="relative mt-4">
                    <Sparkle className="absolute -top-6 left-[42%] text-coral h-8 w-8 hidden md:block" />
                    <Sparkle className="absolute top-12 right-2 text-butter h-12 w-12 hidden md:block" />
                    <Sparkle className="absolute -bottom-2 left-2 text-sage h-7 w-7 hidden md:block" />

                    <motion.h2
                        initial={{ opacity: 0, y: 26 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true }}
                        transition={{ duration: 0.9, ease: [0.16, 1, 0.3, 1] }}
                        className="font-heading text-[44px] sm:text-6xl lg:text-[88px] leading-[1.02] font-semibold tracking-tight"
                        data-testid="contact-title"
                    >
                        Let’s turn complexity into{" "}
                        <span className="font-accent text-coral text-[44px] sm:text-6xl lg:text-[88px] inline-block -rotate-[3deg] align-baseline">
                            clear
                        </span>{" "}
                        visual experiences.
                    </motion.h2>

                    <motion.div
                        initial={{ opacity: 0, y: 22 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true }}
                        transition={{
                            duration: 0.85,
                            ease: [0.16, 1, 0.3, 1],
                            delay: 0.18,
                        }}
                        className="mt-10 flex flex-wrap items-center gap-4"
                    >
                        <a
                            href="mailto:mona.saedi90@gmail.com"
                            data-testid="contact-email-btn"
                            className="pill-btn inline-flex items-center gap-2.5 rounded-full bg-[#2D2A26] text-cream px-7 py-4 text-base md:text-lg font-body font-semibold"
                        >
                            mona.saedi90@gmail.com
                            <span aria-hidden>↗</span>
                        </a>
                    </motion.div>
                </div>

                <footer
                    data-testid="site-footer"
                    className="mt-16 pt-8 border-t border-[rgba(45,42,38,0.12)] flex flex-col md:flex-row items-start md:items-center justify-between gap-4 font-body text-sm text-text-secondary"
                >
                    <p>© {new Date().getFullYear()} Mona Saedi. All rights reserved.</p>
                    <div className="flex items-center gap-5">
                        <a
                            href="https://www.monasaedi.com/"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="hover:text-text-primary transition-colors"
                        >
                            monasaedi.com
                        </a>
                        <a
                            href="mailto:mona.saedi90@gmail.com"
                            className="hover:text-text-primary transition-colors"
                        >
                            Email
                        </a>
                        <span className="font-accent text-coral text-lg rotate-[-2deg]">
                            made with care ✦
                        </span>
                    </div>
                </footer>
            </div>
        </section>
    );
};

export default Contact;
